var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-800 text-center text-lg text-white py-4 block lg:hidden flex flex-column"},[_c('font-awesome-icon',{staticClass:"mx-4 text-2xl cursor-pointer",class:{
      'opacity-50': !_vm.sidebarExpanded,
    },attrs:{"icon":['fas', 'bars']},on:{"click":_vm.toggleSidebar}}),_c('div',{staticClass:"text-center flex-1 pr-4"},[_vm._v(" Koordinavimo sistema ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }